function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.261 14.923l-4.16.976.976-4.16L12.337 1.48a1.285 1.285 0 011.82-.001l1.366 1.365a1.29 1.29 0 010 1.82L5.26 14.923zm9.808-9.804l-3.187-3.186m2.269 4.104l-3.179-3.194M5.423 14.762l-3.184-3.185",
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgEditItem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17
  }, props), _ref);
}

export default SvgEditItem;